import { Link, useNavigate } from 'react-router-dom'
import { useCallback, useEffect, useRef, useState } from 'react'
import { getSearchCategory } from '../../utils'
import { useTranslation } from 'react-i18next'
import { useRecoilState } from 'recoil'
import { searchAtom } from '../../recoil/atom/SearchAtom'
import { DebounceInput } from 'react-debounce-input'
//import searchSuggestions from 'assets/data/search_auto_complete.json'
import { apiInstance } from '../../configuration/axios'
import React from 'react'
const HeaderFormSearch = () => {
  const navigate = useNavigate()
  const seatchCategory = getSearchCategory()
  const { t } = useTranslation()
  const [searchValue, setSearch] = useRecoilState(searchAtom)
  const [searchSuggestions, setSearchSuggestions] = useState<string[]>([])
  const [isOpenSuggestion, setIsOpenSuggestion] = useState(false)
  const [suggestWord, setSuggestWord] = useState<string[]>([])
  const handleChange = (e: any) => {
    // console.log('searchState',_)
    setSearch(prev => {
      return { ...prev, category: e.target.value }
    })
  }
  const wrapperRef = useRef(null)
  useOutsideAlerter(wrapperRef)
  const handleSearch = (event: any) => {
    event.preventDefault()
    if (searchValue.category !== '')
      navigate(`/search?keyword=${searchValue.keyword}&category=${searchValue.category}`)
    else console.log('searchValue', searchValue)
    return
  }
  const handleSelectSuggestion = (event: any) => {
    const val = event.target.innerText
    setSearch(prev => {
      return { ...prev, keyword: val }
    })
    setIsOpenSuggestion(false)
  }

  const handleInputKeyword = useCallback(
    (e: any) => {
      setSearch(prev => {
        return { ...prev, keyword: e.target.value }
      })
      setIsOpenSuggestion(true)
    },
    [setSearch]
  )

  function useOutsideAlerter(ref: any) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event: any) {
        if (ref.current && !ref.current.contains(event.target)) {
          setIsOpenSuggestion(false)
        }
      }
      // Bind the event listener
      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        // Unbind the event listener on clean up
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [ref])
  }

  const getSuggestion = async() =>  apiInstance.get(`autocomplete`).then(res => {
    
     setSearchSuggestions(res.data)
  })

  useEffect(() => {   
    if (searchValue?.keyword && searchValue.keyword?.length > 0) {
      const suggest = searchSuggestions
        .filter(e => e.includes(searchValue.keyword ?? ''))
        .slice(0, 6)
      setSuggestWord(suggest)
    } else {
      setIsOpenSuggestion(false)
    }
  }, [searchValue.keyword])

  useEffect(() => {
    
    getSuggestion();
    setSearch(prev => {
      return { ...prev, category: 'all', keyword: '' }
    })
    return () => {
      setSearch(prev => {
        return { ...prev, category: 'all', keyword: '' }
      })
    }
  }, [])

  return (
    <form onSubmit={handleSearch} ref={wrapperRef}>
      <div className="row">
        <div className="col-12">
          <div className="form-group">
            <input
              type="text"
              className=" h-60"
              placeholder="กรุณาพิมพ์คำที่ต้องการ เช่น ยาสมุนไพร, ผิวขาว..."
              onChange={handleInputKeyword}
              value={searchValue.keyword ?? ''}
            />
            {isOpenSuggestion && suggestWord.length > 0 && (
              <div className="suggestionSearch">
                <ul>
                  {suggestWord.map((item, index) => (
                    <li onClick={handleSelectSuggestion} key={`suggestion${index}`}>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
        <div className="col-12 col-md-8">
          <div className="form-group">
            <select className="legSelect h-60" name="option" id="" onChange={handleChange}>
              <option value="all">ตัวช่วยการค้นหา : (ทั้งหมด)</option>
              {seatchCategory.map(e => (
                <option key={e.key} value={e.key}>
                  {t(`menu.${e.key}`)}
                </option>
              ))}
            </select>
          </div>
        </div>
        <div className="col-7 col-md-4">
          <a
            href="#"
            onClick={handleSearch}
            className="theme-btn btn-style-three w-100 text-center">
            <span className="txt">
              <span className="icon fa fa-search mr-2"></span> ค้นหา
            </span>
          </a>
        </div>
      </div>
    </form>
  )
}

export default HeaderFormSearch;
